import { TrackingCategory } from '@bridebook/web/app-basic/lib/analytics/tracking-category';
import { TrackingEvent } from '@bridebook/web/app-basic/lib/analytics/tracking-event';
import { getScreenType } from '@bridebook/web/app-basic/lib/app/selectors';
import { ThunkAction } from '@bridebook/web/app-basic/lib/types';
import { CountryCodes } from '@bridebook/toolbox/src/gazetteer';
import { getAsPathNormalized } from '@bridebook/web/lib/utils/url';

//Viewed logged out page
export const viewedLoggedOutPage: (payload: {
  title: string;
  selectedWeddingCountry: CountryCodes;
  trackingTarget?: 'BigQuery';
}) => ThunkAction<void> =
  (payload: {
    title: string;
    selectedWeddingCountry: CountryCodes;
    trackingTarget?: 'BigQuery';
  }): ThunkAction<void> =>
  (_, getState, { analyticsService }) => {
    const state = getState();
    const path = getAsPathNormalized();
    const url = document.URL;

    const { isMobile: mobileApp } = getScreenType(state);

    return analyticsService.getMethods(TrackingCategory.LoggedOut).track({
      event: TrackingEvent.ViewedLoggedOutPage,
      ...payload,
      mobileApp,
      path,
      name: path,
      url,
    });
  };
